export default {
  MOUNTED: 'application/MOUNTED'
};
